import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import AgentNavbar from "../../../component/AgentNavbar";
import flightsvg from "../../../component/img/flightsvg.svg";
import { BarChart, ChevronRight, User, LogOut, Key } from "react-feather";

function AgentReport() {
  return (
    <>
      <AgentNavbar />
      <div className="bgagent">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-start agenth1 pt-3 font4">
              <span>My Reports</span>
            </h1>

            <span className="">
              <span className="text-muted">Dashboard</span>
              <span className="text-muted">
                <ChevronRight size={12} />
              </span>
              <span className="text-muted">My Reports</span>
            </span>
          </div>

          <div className="container">
            <div className="row g-3">
              <div className="col-md-4">
                <Link to="/booking-report">
                  <div className="crdmain p-3">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="48px"
                        viewBox="0 -960 960 960"
                        width="48px"
                        fill="#000000"
                      >
                        <path d="M480-283q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm0-167q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm0-167q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm340 457H140q-24.75 0-42.37-17.63Q80-195.25 80-220v-153q37-8 61.5-37.5T166-480q0-40-24.5-70T80-587v-153q0-24.75 17.63-42.38Q115.25-800 140-800h680q24.75 0 42.38 17.62Q880-764.75 880-740v153q-37 7-61.5 37T794-480q0 40 24.5 69.5T880-373v153q0 24.75-17.62 42.37Q844.75-160 820-160Zm0-60v-109q-38-26-62-65t-24-86q0-47 24-86t62-65v-109H140v109q39 26 62.5 65t23.5 86q0 47-23.5 86T140-329v109h680ZM480-480Z" />
                      </svg>
                    </div>
                    <div className="text-center mb-3 font4 rpt1 text-dark">
                      Booking Report
                    </div>
                    <p className="text-muted">
                      The Booking Report displays details of all bookings,
                      including status, customer information, payment status,
                      and revenue, to track booking trends and performance.
                    </p>
                  </div>
                </Link>
              </div>

              <div className="col-md-4">
                <div className="crdmain p-3">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="48px"
                      viewBox="0 -960 960 960"
                      width="48px"
                      fill="#000000"
                    >
                      <path d="M480-40 359-161H180q-24 0-42-18t-18-42v-600q0-24.75 18-42.38Q156-881 180-881h600q24 0 42 17.62 18 17.63 18 42.38v600q0 24-18 42t-42 18H601L480-40ZM180-258q60-56 135.9-90.5 75.89-34.5 164-34.5 88.1 0 164.1 34.5T780-258v-563H180v563Zm302-204q58 0 98-40t40-98q0-58-40-98t-98-40q-58 0-98 40t-40 98q0 58 40 98t98 40ZM235-221h490v-9q-54-46-116-69.5T480-323q-67 0-129 23.5T235-230v9Zm247-301q-32.5 0-55.25-22.75T404-600q0-32.5 22.75-55.25T482-678q32.5 0 55.25 22.75T560-600q0 32.5-22.75 55.25T482-522Zm-2-18Z" />
                    </svg>
                  </div>
                  <div className="text-center mb-3 font4 rpt1">
                    Customer Report
                  </div>
                  <p>
                    The Customer Report provides insights into customer
                    demographics, booking history, preferences, and total spend,
                    helping to analyze customer behavior and improve service.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="crdmain p-3">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="48px"
                      viewBox="0 -960 960 960"
                      width="48px"
                      fill="#000000"
                    >
                      <path d="M120-120v-76l60-60v136h-60Zm165 0v-236l60-60v296h-60Zm165 0v-296l60 61v235h-60Zm165 0v-235l60-60v295h-60Zm165 0v-396l60-60v456h-60ZM120-356v-85l280-278 160 160 280-281v85L560-474 400-634 120-356Z" />
                    </svg>
                  </div>
                  <div className="text-center mb-3 font4 rpt1">
                    Revenue Report
                  </div>
                  <p>
                    The Revenue Report tracks total earnings from bookings,
                    including breakdowns by hotel, flight, and bus, to analyze
                    financial performance over specific periods.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentReport;
